module.exports = __webpack_public_path__ + "img/contraceptive-pill.2d54f111.png";